<template>
  <v-container style="background-color: #F0F0EF; height: 535px; overflow: auto">
    <v-row>
      <v-col>
        <div class="d-flex justify-end">
          <span class="mr-3 d-flex align-center search-title">
            Assign all tasks</span
          >
          <AssignmentMenu
            v-if="!selectAll"
            :selectAll="true"
            @addIndividualUser="addSelectionToAll($event)"
            :disabledView="disabledView"
          />

          <AssignmentTaskRemoveButton
            v-if="selectAll"
            :selectAll="selectAll"
            class="button-hover"
            :disabledView="disabledView"
            @remove="removeSelectAll"
          />
        </div>

        <div class=" d-flex justify-start mt-5 flex-nowrap flex-column">
          <v-col
            v-for="(template, index) of selectedTemplates"
            :key="index"
            class="d-flex justify-start  flex-nowrap "
            style="margin-bottom: 25px; margin-left: -40px;"
          >
            <div class="select-all-button">
              <AssignmentMenu
                v-if="
                  !templateSelectAll.find(item => item.title === template.title)
                "
                :selectAll="true"
                @addIndividualUser="addSelectionToAll($event, template)"
                :disabledView="disabledView"
              />

              <AssignmentTaskRemoveButton
                v-if="
                  templateSelectAll.find(item => item.title === template.title)
                "
                :selectAll="
                  templateSelectAll.find(item => item.title === template.title)
                "
                class="button-hover"
                :disabledView="disabledView"
                @remove="removeSelectAll(template)"
              />
            </div>

            <div
              class=" d-flex align-start justify-start pr-2 text-firefox"
              v-if="
                receivedData.activities.find(
                  item => item.title === template.title
                )
              "
            >
              <p class="rotate-text">{{ template.title }}</p>
            </div>
            <div class="mr-4 right-side">
              <div
                v-for="(activity, activityIndex) of receivedData.activities"
                :key="activityIndex"
              >
                <v-card
                  v-if="activity.title === template.title"
                  height="130px"
                  max-width="800px"
                  width="585px"
                  class="d-flex flex-column align-center  "
                  elevation="0"
                  style="display: relative; margin-bottom: 30px; margin-left:20px;"
                  :disabled="disabledView"
                >
                  <v-sheet class="card-title" width="220" height="30" rounded>
                    <div class="text-truncate">
                      <span v-if="activity.label" :title="activity.label">
                        {{ activity.label }} - Activity</span
                      >
                      <span v-else-if="activity.id" :title="activity.id">
                        {{ getObjectTypeLabel(activity.object_type) }} ID
                        {{ activity.id }} - Activity</span
                      >
                      <span v-else :title="activity.object_uuid">
                        {{ getObjectTypeLabel(activity.object_type) }} UUID -
                        {{ activity.object_uuid }}</span
                      >
                    </div>
                  </v-sheet>
                  <v-card-text
                    style="overflow: auto; margin-top: 3px;"
                    class="d-inline-flex  "
                  >
                    <v-sheet
                      v-for="(task, i) of activity.tasks"
                      :key="i"
                      height="55"
                      rounded
                      outlined
                      width="130"
                      class="ml-2 d-flex flex-column justify-space-between"
                    >
                      <span
                        class="task-text text-truncate"
                        :title="task.title"
                        >{{ task.title }}</span
                      >

                      <div
                        class="d-flex align-center justify-end pr-2 pl-2"
                        style="width: 100%;"
                        v-if="
                          task.user_assignee_id ||
                            (task.company_id &&
                              !task.user_assignee_id &&
                              activity.company &&
                              activity.company.length <= 0)
                        "
                      >
                        <span
                          class="text-truncate"
                          :title="
                            task.user_assignee_id
                              ? getUserName(task.user_assignee_id)
                              : getCompanyName(task.company_id)
                          "
                          >{{
                            task.user_assignee_id
                              ? getUserName(task.user_assignee_id)
                              : getCompanyName(task.company_id)
                          }}</span
                        >
                        <AssignmentTaskRemoveButton
                          :tasks="task"
                          class="button-hover"
                          :disabledView="disabledView"
                          @remove="removeTaskAssignee(task)"
                        />
                      </div>
                      <div
                        v-else-if="!task.user_assignee_id"
                        class="d-flex align-end justify-end pt-2 "
                        style="width: 100%;"
                      >
                        <AssignmentMenu
                          :key="i"
                          :activity="activity"
                          :disabledView="disabledView"
                          @addIndividualUser="
                            addIndividualUser($event, i, activityIndex)
                          "
                        />
                      </div>
                    </v-sheet>
                  </v-card-text>
                  <div
                    style="width: 97%;   "
                    class="d-inline-flex align-end justify-end"
                  >
                    <div v-for="(company, i) of activity.company" :key="i">
                      <AssignmentRemoveButton
                        class="button-hover"
                        :actionType="actionType"
                        :activity="activity"
                        :company="company"
                        @remove="remove($event)"
                      />
                    </div>

                    <div class="ml-2 mt-2">
                      <AssignmentMenu
                        :activity="activity"
                        :activityMenu="true"
                        @addCompanyOrUser="addCompanyOrUser($event, activity)"
                      />
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
          </v-col>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { activitiesTasksDataMixin } from "../../../../mixins/field/activitiesTasksDataMixin";
import AssignmentMenu from "./_Organisms/AssignmentMenu.vue";
import AssignmentRemoveButton from "./_Molecules/AssignmentRemoveButton.vue";
import AssignmentTaskRemoveButton from "./_Molecules/AssignmentTaskRemoveButton.vue";
import _ from "lodash";

export default {
  name: "WorkOrderAssignment",

  mixins: [activitiesTasksDataMixin],

  components: {
    AssignmentMenu,
    AssignmentRemoveButton,
    AssignmentTaskRemoveButton
  },

  props: {
    receivedData: {
      type: Object
    },
    disabledView: {
      type: Boolean
    },
    actionType: {
      type: String
    }
  },

  data() {
    return {
      /**
       * Templateselectall is the array of users that are chosen in the specific templates
       */
      templateSelectAll: [],
      /**
       * 1 user allowerd, all tasks are assigned with this user
       */
      selectAll: null
    };
  },

  computed: {
    /**
     * @returns - unique templates that were selected, used in v-for to display activities inside left bar.
     */
    selectedTemplates() {
      return this.$store.state.workOrders.selectedTemplates;
    }
  },

  methods: {
    /**
     * adds a user or company to each task if selected in activity button, if user adds 2 companies, the company_id is not sent and the list of users
     * gets filtered from the selected companies (to be implemented)
     */
    addCompanyOrUser(e, activity) {
      for (const tasks of activity.tasks) {
        if (e.type === "web" || e.type === "mobile") {
          tasks.user_assignee_id = e.id;
        }
        if (e.address) {
          tasks.company_id = e.id;
        }
        if (activity.company.find(item => item.id === e.id)) {
          return this.$toasted.global.toast_error("Company already selected.");
        }
        this.$nextTick(() => {
          if (activity.company && activity.company.length >= 2) {
            tasks.company_id = null;
          }
        });
      }
      if (e.type !== "web" || e.type !== "mobile") {
        activity.company.push(e);
      }
    },

    /**
     * individualy adds a user to the selected task, if a company is added it clears the assigned user.
     */
    addIndividualUser(user, task, activity) {
      if (user.address) {
        this.receivedData.activities[activity].tasks[task].company_id = user.id;
        this.receivedData.activities[activity].tasks[
          task
        ].user_assignee_id = null;
      } else {
        this.receivedData.activities[activity].tasks[task].user_assignee_id =
          user.id;
        this.receivedData.activities[activity].tasks[task].company_id = null;
      }
    },
    /**
     * removes company or user id from the activity and tasks
     */
    remove(activity, selectedCompany) {
      let index = activity.company.indexOf(selectedCompany);
      activity.company.splice(index, 1);

      for (const tasks of activity.tasks) {
        if (activity.company.length === 1) {
          tasks.company_id = activity.company[0].id;
        } else {
          tasks.company_id = null;
        }
      }
      for (const tasks of activity.tasks) {
        if (activity.company.find(item => !item.company_id)) {
          tasks.user_assignee_id = null;
        } else {
          tasks.company_id = null;
        }
      }
    },
    /**
     * Individualy removes the user or company id, also clears the task schedule if its created.
     * Removes global user if selected.
     * Removes template user if selected
     *
     */
    removeTaskAssignee(e) {
      if (this.receivedData.activities.includes("company")) {
        for (const activities of this.receivedData.activities) {
          if (activities.company.find(item => !item.company_id)) {
            let index = activities.company.findIndex(item => item === e);
            activities.company.splice(index, 1);
          }
        }
      }
      if (e.company_id && !e.user_assignee_id) {
        e.company_id = null;
      }
      let index = this.templateSelectAll.findIndex(
        item => item.id === e.user_assignee_id
      );
      this.templateSelectAll.splice(index, 1);
      e.end = null;
      e.start = null;
      e.scheduled_date = null;
      e.user_assignee_id = null;
      this.selectAll = null;
    },
    /**
     * Adds the selected user or company to all tasks.
     * Uses selectAll variable to add a user so it appears in the taskRemoveButton
     * Templateselectall is the array of users that are chosen in the specific templates
     *
     */
    addSelectionToAll(user, template = null) {
      for (const activity of this.receivedData.activities) {
        for (const task of activity.tasks) {
          if (!template || (template && activity.title === template.title)) {
            if (!user.company_id) {
              task.user_assignee_id = user.id;
              task.company_id = null;
            } else {
              task.company_id = user.id;
              task.user_assignee_id = null;
            }
          }
        }
      }
      if (!template) {
        this.selectAll = user;
        this.templateSelectAll = [];
      } else {
        let users = Object.assign({ title: template.title }, user);
        this.templateSelectAll.push(users);
        this.selectAll = null;
      }
    },
    /**
     * removes user from select all option or from specific template.
     */
    removeSelectAll(val) {
      if (val) {
        let index = this.templateSelectAll.findIndex(
          item => item.title === val.title
        );
        this.templateSelectAll.splice(index, 1);
      } else {
        this.selectAll = null;
      }
    }
  }
};
</script>
<style scoped>
.search-title {
  font-size: 10px;
  color: #b8b8b7;
  font-weight: bold;
}
.left-side {
  border-left: 1px solid black;
  height: 395px;
  position: absolute;
  width: 1px;
  border-color: rgba(59, 59, 59, 0.212);
  top: 20px;
  left: 215px;
}
.card-title {
  position: absolute;
  top: -15px;
  left: 10px;

  font: normal normal normal 12px Roboto;
  letter-spacing: 0.1px;
  color: #666666;
  opacity: 1;
  text-align: left;
  padding-left: 5px;
  padding-top: 2px;
}

.rotate-text {
  writing-mode: vertical-rl;
  text-orientation: sideways-right;
  transform: rotate(180deg);
  padding-top: 10px;
  text-align: left;
  font: normal normal normal 14px Roboto;
  letter-spacing: 0.11px;
  color: #666666;
  opacity: 1;
}

.right-side {
  border-left: 1px solid #666666;
  transform: translateX(0px);
}

.button-hover:hover >>> img {
  display: none;
}
.button-hover >>> .v-icon {
  display: none;
}
.button-hover:hover >>> .v-icon {
  display: inherit;
}

.task-text {
  text-align: left;
  font: normal normal normal 10px Roboto;
  letter-spacing: 0.08px;
  color: #666666;
  opacity: 1;
  margin-left: 10px;
  margin-top: 5px;
}
.task-sheet {
  border: 1px solid #c9c9c9;
}
.select-all-button {
  transform: translate(45px, -35px);
}
.home-form-container .footer-button {
  font-size: 8px;
  height: 22px !important;
  min-width: 70px !important;
}
/**
applies only these changes when using firefox
*/
@supports (-moz-appearance: none) {
  .select-all-button {
    transform: translate(26px, -35px);
  }
  .text-firefox {
    transform: translate(-10px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/WorkOrderForm/WorkOrderAssignment.vue